import { TieredSelectProps } from '@procore/core-react/dist/_typedoc/TieredSelect/TieredSelect.types.json';
import * as React from 'react';
export default {
  TieredSelectProps,
  React
};